<template>
  <div class="mainApp" id="poper-smartnlp-FrameBlock">
    <div
      class="smartnlp-headerApp"
      :style="'background:' + chatDataCenter.linkInfo.windowColor"
    >
      <img
        class="smartnlp-infobar-pic1"
        v-if="chatDataCenter.linkInfo.windowLogo != undefined"
        :src="$config.fileUrl + chatDataCenter.linkInfo.windowLogo"
        alt="用户头像"
      />
      <!--<span class="smartnlp-robot-name"  v-if="chatDataCenter.chatRoom.sessionType=='2'&&chatDataCenter.chatRoom.userId!=null&&chatDataCenter.chatRoom.queueFlag==0">-->
      <!--{{chatDataCenter.userSetInfo==null||chatDataCenter.userSetInfo.nickname==''||chatDataCenter.userSetInfo.nickname==null?chatDataCenter.linkInfo.artificialName:chatDataCenter.userSetInfo.nickname}}-->
      <!--({{chatDataCenter.chatRoom.senderType==1?'顾客':chatDataCenter.chatRoom.senderType==2?'客服':''}}{{chatDataCenter.chatRoom.getWaitTime()}})-->
      <!--</span>-->
      <span class="smartnlp-robot-name">{{
        chatDataCenter.linkInfo.windowTitle
      }}</span>
      <div class="smartnlp-toolbar">
        <span class="smartnlp-toolbar-voice">
          <img
            src="../../../static/images/app/horn-c.png"
            style="width: 20px;height: 20px;"
            v-if="
              chatDataCenter.chatRoom.sessionType == '2' &&
                chatDataCenter.chatRoom.userId != null &&
                chatDataCenter.set.tipSound == '1'
            "
            @click="chatDataCenter.set.tipSound = '2'"
          />
          <img
            src="../../../static/images/app/horn-x.png"
            style="width: 20px;height: 20px;"
            v-if="
              chatDataCenter.chatRoom.sessionType == '2' &&
                chatDataCenter.chatRoom.userId != null &&
                chatDataCenter.set.tipSound == '2'
            "
            @click="chatDataCenter.set.tipSound = '1'"
          />
          <img
            src="../../../static/images/app/icon-s.png"
            style="width: 21px;height: 20px;"
            v-if="getRobotToUserButton() == '1'"
            @click="transferStaffSession"
          />
        </span>
        <span class="smartnlp-toolbar-large" v-if="chatDataCenter.set.isIFrame">
          <img
            src="../../../static/images/app/icon-x.png"
            @click="hideIframe"
          />
        </span>
      </div>
    </div>
    <div
      :class="
        icon.operateShow
          ?
          chatDataCenter.bottomLabel.length > 0
            ? isVoice
              ? 'smartnlp-chat-main2-voice'
              : 'smartnlp-chat-main2'
            : isVoice
              ? 'smartnlp-chat-main2-noBottom-voice'
              : 'smartnlp-chat-main2-noBottom'
          : icon.emojiShow
          ? chatDataCenter.bottomLabel.length > 0
            ? isVoice
              ? 'smartnlp-chat-main3-voice'
              : 'smartnlp-chat-main3'
            : isVoice
              ? 'smartnlp-chat-main3-noBottom-voice'
              : 'smartnlp-chat-main3-noBottom'
          : icon.focusShow
          ? chatDataCenter.bottomLabel.length > 0
            ? isVoice
              ? 'smartnlp-chat-main4-voice'
              : 'smartnlp-chat-main4'
            : isVoice
            ? 'smartnlp-chat-main4-noBottom-voice'
            : 'smartnlp-chat-main4-noBottom'
          : chatDataCenter.bottomLabel.length > 0
          ? isVoice
            ? 'smartnlp-chat-main4-voice'
            : 'smartnlp-chat-main4'
          : isVoice
          ? 'smartnlp-chat-main4-noBottom-voice'
          : 'smartnlp-chat-main4-noBottom'
      "
      id="wrapper"
      @touchend="touchContent($event)"
    >
      <div
        id="notice"
        class="smartnlp-notice"
        v-if="
          chatDataCenter.notice.show &&
            chatDataCenter.notice.noticeInfo.title != null &&
            chatDataCenter.notice.noticeInfo.title != ''
        "
      >
        <img src="../../../static/images/t-c.png" />
        <span @click="detail()">{{
          chatDataCenter.notice.noticeInfo.title
        }}</span>
        <a class="notice-close" @click="chatDataCenter.notice.show = false">
          <img src="../../../static/images/c.png" />
        </a>
      </div>
      <div
        class="scroller"
        :style="
          chatDataCenter.chatRoom.sessionType == '1'
            ? 'padding-bottom: 150px;min-height:101%;'
            : 'padding-bottom: 50px;min-height:101%;'
        "
      >
        <div id="content" class="smartnlp-chat-msg-content">
          <div class="smartnlp-chatRecord " id="pullDown">
            <a class="pullDownLabel" style="display: none;" v-if="chatDataCenter.isLoadMessage"
            >加载更多</a
            >
          </div>
          <!--骨架屏-->
          <skeleton
            :paragraph="paragraph"
            :active="true"
            v-if="chatDataCenter.showSkeleton"
          />
          <ul
            class="smartnlp-msg-history-list contentDivWidth2"
            v-if="chatDataCenter.chatRoom != null"
          >
            <li
              class="smartnlp-li"
              v-for="(item, index) in chatDataCenter.chatRoom.messages"
            >
              <!--系统消息 -->
              <div
                class="martnlp-system"
                v-if="item.messageDirection == 'S' && item.messageType != 'S2'"
              >
                {{ item.getSendTime() }}
                <span
                  v-html="
                    item.getSystemHtml(
                      chatDataCenter.chatRoom.sessionId,
                      item.sessionId == chatDataCenter.chatRoom.sessionId
                    )
                  "
                ></span>
              </div>
              <div
                class="martnlp-system"
                v-if="item.messageDirection == 'U' && item.messageStatus == 40"
              >
                {{ item.getSendTime() }} 客服撤回一条消息
              </div>
              <!--用户->客服 -->
              <div
                class="smartnlp-msg-model smartnlp-right-msg clearfix"
                v-if="item.messageDirection == 'C'"
              >
                <div class="smartnlp-msg-head-pic">
                  <img v-if="(item.senderAvatar==null||item.senderAvatar=='')&&chatDataCenter.linkInfo!=null" v-lazy="$config.fileUrl+chatDataCenter.linkInfo.userAvator" :key="$config.fileUrl+chatDataCenter.linkInfo.userAvator">
                  <img v-if="item.senderAvatar!=null&&item.senderAvatar!=''" v-lazy="$config.fileUrl+item.senderAvatar" :key="$config.fileUrl+item.senderAvatar">
                </div>
                <div class="smartnlp-msg-content clearfix">
                  <!--<p class="smartnlp-right-name"><span>{{item.getSendTime()}}</span><span v-if="item.senderNickname==null||item.senderNickname==''">我</span><span v-else>{{item.senderNickname}}</span></p>-->
                  <div
                    class="smartnlp-msg-news smartnlp-msg-right-color clearfix"
                    :style="'background:' + chatDataCenter.linkInfo.windowColor"
                  >
                    <v-message-show
                      v-if="item.showType()"
                      :message="item"
                    ></v-message-show>
                    <viewer v-if="!item.showType()">
                      <p v-html="item.getHtml()"></p
                      ></viewer>
                  </div>
                </div>
                <div
                  class="error-right"
                  title="发送失败"
                  v-show="item.messageStatus == -1"
                >
                  <img src="../../../static/images/fail.png" />
                </div>
                <div class="yidu-right" v-show="item.messageStatus == 0">
                  发送中
                </div>
                <!--<div class="weidu-right" v-show="item.messageStatus==10">未读</div>-->
                <!--<div class="yidu-right" v-show="item.messageStatus == 20">已读</div>-->
              </div>
              <!--客服->用户 -->
              <div
                class="smartnlp-msg-model smartnlp-left-msg clearfix contentDiv"
                v-if="
                  item.messageDirection == 'U' &&
                    $messageType.L != item.messageType &&
                    item.messageStatus != 40
                "
                style=" margin: 20px 0;"
              >
                <div
                  v-if="item.messageType == 'R'"
                  class="smartnlp-msg-head-pic"
                >
                  <img
                    v-if="chatDataCenter.linkInfo != null"
                    v-lazy="
                      $config.fileUrl + chatDataCenter.linkInfo.robotAvator
                    "
                    :key="$config.fileUrl + chatDataCenter.linkInfo.robotAvator"
                  />
                </div>
                <div
                  v-if="item.messageType != 'R' && item.messageType != 'H'"
                  class="smartnlp-msg-head-pic"
                >
                  <img
                    v-if="
                      (item.senderAvatar == null || item.senderAvatar == '') &&
                        chatDataCenter.linkInfo != null
                    "
                    v-lazy="
                      $config.fileUrl + chatDataCenter.linkInfo.artificialAvator
                    "
                    :key="$config.fileUrl + chatDataCenter.linkInfo.artificialAvator"
                  />
                  <img
                    v-if="item.senderAvatar != null && item.senderAvatar != ''"
                    v-lazy="$config.fileUrl + item.senderAvatar"
                    :key="$config.fileUrl + item.senderAvatar"
                  />
                </div>
                <div class="smartnlp-msg-content clearfix">
                  <p class="smartnlp-left-name" v-if="item.messageType == 'R'">
                    <span v-if="chatDataCenter.linkInfo != null">{{
                      chatDataCenter.linkInfo.robotName
                    }}</span>
                    <span>{{ item.getSendTime() }}</span>
                  </p>
                  <p class="smartnlp-left-name" v-if="item.messageType != 'R' && item.messageType != 'H'">
                    <span
                      v-if="
                        (item.senderNickname == null ||
                          item.senderNickname == '') &&
                          chatDataCenter.linkInfo != null
                      "
                    >{{ chatDataCenter.linkInfo.artificialName }}</span
                    >
                    <span
                      v-if="
                        item.senderNickname != null && item.senderNickname != ''
                      "
                    >{{
                        item.senderCode == "" || item.senderCode == null
                          ? item.senderNickname
                          : item.senderNickname + "(" + item.senderCode + ")"
                      }}</span
                    >
                    <span>{{ item.getSendTime() }}</span>
                  </p>
                  <div
                    class="smartnlp-msg-answer smartnlp-msg-left-color clearfix"
                    v-if="item.messageType != 'H'"
                  >
                    <div :style="{ height: item.height, overflow: 'hidden' }">
                      <v-message-show
                        v-if="item.showType()"
                        :message="item"
                      ></v-message-show>
                      <viewer v-if="!item.showType()">
                        <p v-if="!item.answerType" v-html="item.getHtml()"></p>
                        <!-- json类型答案且引导话术不为空 -->
                        <p v-if="item.answerType && item.answerType ==='json' && item.getHtml()" v-html="item.getHtml()"></p>
                      </viewer>
                    </div>

                    <!--用于长文本的展开收起高度改变-->
                    <div
                      class="openMore"
                      v-if="item.isHasOpen"
                      @click="foldMore(item, $event)"
                    >
                      <span>{{ item.isOpen ? "收起" : "展开" }}</span>
                      <img
                        src="../../../static/images/iconArrowDown.png"
                        class="openImg"
                        v-if="!item.isOpen"
                      />
                      <img
                        src="../../../static/images/iconArrowUp.png"
                        class="openImg"
                        v-if="item.isOpen"
                      />
                    </div>
                    <v-solve-show
                      :message="item"
                      :messageIndex="index"
                    ></v-solve-show>
                  </div>
                  <json-card v-if="item.answerType && item.answerType === 'json'" :message="item" />
                </div>

                <hot-question v-if="item.messageType === 'H' &&chatDataCenter.labelListNew.length > 0"/>
                <quick-entry v-if="item.messageType === 'H' && chatDataCenter.quickEntryList.length > 0" />
              </div>

              <!--机器人待回复动画 -->
              <div
                class="smartnlp-msg-model smartnlp-left-msg clearfix fadeIn"
                v-if="
                  item.messageDirection == 'U' &&
                    $messageType.L == item.messageType
                "
              >
                <div class="smartnlp-loading">
                  <img src="../../../static/images/loading.gif" />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!--<div class="smartnlp-tool-block clearfix" v-if="chatDataCenter.chatRoom.sessionType=='1'">-->
      <!--<span class="smartnlp-tool-list">-->
      <!--<a :class="{'smartnlp-tool-active':index==chatDataCenter.quickConsult.chooseIndex}"  @click="quickConsultSendByContent(index,item)"  v-for="(item,index) in chatDataCenter.quickConsult.list" >{{item}}</a>-->
      <!--</span>-->
      <!--</div>-->
    </div>

    <div class="smartnlp-footer">
      <bottom-label v-if="chatDataCenter.bottomLabel.length > 0" />
      <div style="padding: 5px 10px" v-if="!isVoice" :class="{ operateShow: icon.operateShow }">
        <div class="smartnlp-footer-first" style="background: #fff; padding: 0; height: 50px; border-radius: 8px" :class="{ 'operateShow-footer-first': icon.operateShow }">
          <a class="yuyin" v-if="!isVoice && isWeixin" @click="showVoice">
            <img src="../../../static/images/yuyin.png" />
          </a>
          <input
            v-model.trim="sendText"
            class="chat-input"
            @keyup.enter="sendMessage"
            type="text"
            placeholder="请简短描述您的问题"
            @focus="inputFocus()"
            @blur="inputBlurinputBlur()"
            @input="getSuggest($event)"
            style="margin-top: 6px;margin-bottom: 0px;margin-left: 0;margin-right: 0;"
          />
          <a class="biaoqing" v-if="!robotSessionFlag" @click="clickEmojiShow">
            <img src="../../../static/images/app/sm.png" />
          </a>
          <a class="add" v-if="sendText == ''" @click="clickOperateShow">
            <img
              src="../../../static/images/add.png"
              v-show="!icon.operateShow"
            />
            <img
              src="../../../static/images/closeOperation.png"
              v-show="icon.operateShow"
            />
          </a>
          <a
            class="smartnlp-send"
            @click="sendMessage"
            v-if="sendText != '' && !isVoice"
            :style="'background:' + chatDataCenter.linkInfo.windowColor"
          >发送</a>
        </div>
      </div>
      <div style="padding: 5px 10px;position: relative;" v-if="isVoice" :class="{ operateShow: icon.operateShow }">
        <div
          class="voiceStart"
          @touchstart="start($event)"
          @touchend="end($event)"
        ></div>
        <div class="voiceBox"></div>
        <div class="smartnlp-footer-first" style="background: #fff; padding: 0; height: 50px; border-radius: 8px" :class="{ 'operateShow-footer-first': icon.operateShow }">
          <a class="yuyin keywordBack" v-if="isVoice" @click="showVoice">
            <!--            <img src="../../../static/images/keyword.png" />-->
          </a>
          <div class="chat-input chatTalk" style="position: relative">
            <span style="color: #a3afb7; user-select: none">{{
              showModal ? "松开停止录音" : "长按开始录音"
            }}</span>
          </div>
          <a class="add addpng" v-if="sendText == '' && !icon.operateShow" @click="clickOperateShow" style="user-select: none;">
            <!--            <img-->
            <!--              src="../../../static/images/add.png"-->
            <!--              v-show="!icon.operateShow"-->
            <!--            />-->
            <!--            <img-->
            <!--              src="../../../static/images/closeOperation.png"-->
            <!--              v-show="icon.operateShow"-->
            <!--            />-->
          </a>
          <a class="add closeOperation" v-if="sendText == '' && icon.operateShow" @click="clickOperateShow" style="user-select: none;"></a>
          <a
            class="smartnlp-send"
            @click="sendMessage"
            v-if="sendText != '' && !isVoice"
            :style="'background:' + chatDataCenter.linkInfo.windowColor"
          >发送</a>
        </div>
      </div>
      <div style="padding: 0 10px 5px 10px" v-show="icon.operateShow">
        <div class="smartnlp-footer-second" style="border-radius: 0 0 8px 8px" v-show="icon.operateShow">
          <div class="bottom-list" v-if="!robotSessionFlag">
            <div class="bottom-list-img">
              <img src="../../../static/images/app/img.png" />
            </div>
            <div class="bottom-list-title">照片</div>
            <v-upload-file
              :fileInfo="image"
              @fromUploadFilePage="fromUploadData"
            ></v-upload-file>
          </div>
          <div class="bottom-list" v-if="!robotSessionFlag">
            <div class="bottom-list-img">
              <img src="../../../static/images/app/video.png" />
            </div>
            <div class="bottom-list-title">视频</div>
            <v-upload-file
              :fileInfo="video"
              @fromUploadFilePage="fromUploadData"
            ></v-upload-file>
          </div>
          <div
            class="bottom-list"
            v-if="
            (chatDataCenter.chatRoom.customerEvaluate == null ||
              chatDataCenter.chatRoom.customerEvaluate == 0) &&
              chatDataCenter.evaluation.sessionId != null && !robotSessionFlag
          "
            @click="evaluateByCustomer"
          >
            <div class="bottom-list-img">
              <img src="../../../static/images/app/assess.png" />
            </div>
            <div class="bottom-list-title">评价</div>
          </div>
          <div class="bottom-list" @click="closeSessionByCustomer" v-if="!robotSessionFlag">
            <div class="bottom-list-img">
              <img src="../../../static/images/app/fis.png" />
            </div>
            <div class="bottom-list-title">会话结束</div>
          </div>
          <div class="bottom-list" v-if="robotSessionFlag" @click="transferStaffSession">
            <div class="bottom-list-img">
              <img src="../../../static/images/kefuButton.png" />
            </div>
            <div class="bottom-list-title">人工客服</div>

          </div>
        </div>
      </div>

      <div class="smartnlp-footer-emjon" v-show="icon.emojiShow">
        <ul>
          <li
            v-for="(item, index) in emoji.getEmojis()"
            @click="choiceEmoji(index)"
          >
            <img :src="emoji.getEmojiSrc(index)" />
          </li>
        </ul>
      </div>
    </div>
    <div class="smartnlp-chat-msg-input-disabled" v-if="chatDataCenter.chatRoom==null||chatDataCenter.chatRoom.sessionId==null">
      <p>当前会话已结束，您可以：</p>
      <div class="disabled-button">
        <a class="zixun" :style="'color:'+ chatDataCenter.linkInfo.windowColor+';borderColor:'+ chatDataCenter.linkInfo.windowColor" @click="reJoin">重新接入</a>
        <a  class="pingjia" v-if="(chatDataCenter.chatRoom.customerEvaluate==null||chatDataCenter.chatRoom.customerEvaluate==0)&&chatDataCenter.evaluation.sessionId!=null&&chatDataCenter.evaluation.customerEvaluate === 0" @click="evaluateByCustomer">评价</a>
      </div>
    </div>

    <!--通知通告-->
    <div
      style="width:100%;height:100%;position: fixed; z-index: 5147483647;top:0;background: #ffffff"
      v-show="notice.show"
    >
      <div
        class="smartnlp-notice-close"
        style="text-align: right; padding: 20px;"
      >
        <img
          src="../../../static/images/m-c.png"
          @click="notice.show = false"
          style="width: 10px;height: 10px;"
        />
      </div>
      <div class="smartnlp-notice-content" style="padding: 0 20px 0;">
        <p v-html="chatDataCenter.notice.noticeInfo.remark"></p>
      </div>
    </div>
    <!--<div class="blackBoxSpeak" v-if="isRecording" ref="blackBoxSpeak">-->
    <!--<p class="blackBoxSpeakConent">手指上划，取消发送</p>-->
    <!--</div>-->
    <!--<div class="blackBoxPause" v-if="isPause" ref="blackBoxPause">-->
    <!--<p class="blackBoxPauseContent" style="background: red">松开手指， 取消发送</p>-->
    <!--</div>-->
    <v-evaluation></v-evaluation>
    <v-leave-message></v-leave-message>

    <feedback v-if="chatDataCenter.isOpenFeedback"></feedback>
    <div
      class="smartnlp-suggest"
      v-show="isShowSuggest && chatDataCenter.linkInfo.inputAssociate == 1"
    >
      <ul>
        <li
          v-for="(qs, index) in questionList"
          @touchstart="sendSuggest(qs.text, $event)"
        >
          <img src="../../../static/images/icon_zhi.png" /><span
          v-html="qs.text"
        ></span>
        </li>
      </ul>
    </div>
    <v-loading
      v-if="
        chatDataCenter.loadPage.initLoad ||
          (chatDataCenter.loadPage.requestLoad &&
            chatDataCenter.loadPage.initLoad)
      "
    ></v-loading>
    <voice-modal v-if="showModal" @on-cancel="cancel"/>
  </div>
</template>
<script>
  import chatDataCenter from "../../jsSdk/chatDataCenter";
  import vMessageShow from "../common/messageShow";
  import vSolveShow from "../common/solveShow";
  import vEvaluation from "../medium/evaluation";
  import vLeaveMessage from "../medium/leaveMessage";
  import bus from "../../utils/bus";
  import vLoading from "../medium/loading";
  import emoji from "../../emoji/emoji";
  import vUploadFile from "../common/uploadFile";
  import iScroll from "../../../static/js/iscroll";
  import feedback from "../common/feedback";
  import voiceModal from "../common/voiceModal";
  import skeleton from "../common/skeleton";
  import jsonCard from "../common/jsonCard";
  import common from "../../utils/common";
  export default {
    name: "app-web",
    components: {
      vMessageShow,
      vLoading,
      vEvaluation,
      vLeaveMessage,
      vUploadFile,
      vSolveShow,
      hotQuestion:() => import("../common/hotQuestion"),
      bottomLabel:() => import("../common/bottomLabel"),
      feedback,
      voiceModal,
      skeleton,
      jsonCard,
      quickEntry:() => import("../common/quickEntry"),
    },
    mounted: function() {
      var _this = this;
      _this.initPage();
      _this._initScroll();
      _this.isWeixin=common.isWx()
      console.log('是否是微信', this.isWeixin)
      // _this.initWeiXinSdk();
      // let url = location.href.split("#")[0];
      // if (url.indexOf("code") != -1) {
      //   _this.fetchWeiXinConfig();
      // }
    },
    methods: {
      detail: function() {
        var _this = this;
        _this.notice.show = true;
      },
      clickOperateShow: function() {
        var _this = this;
        _this.icon.operateShow = !_this.icon.operateShow;
        _this.icon.emojiShow = false;
        _this.icon.focusShow = true;
        bus.$emit("scrollToBottomApp", "1");
      },
      clickEmojiShow: function() {
        var _this = this;
        _this.icon.emojiShow = !_this.icon.emojiShow;
        _this.icon.operateShow = false;
        _this.icon.focusShow = true;
        bus.$emit("scrollToBottomApp", "1");
      },
      initPage: function() {
        var _this = this;
        bus.$on("changeEdit", name => {
          if (
            chatDataCenter.chatRoom != null &&
            chatDataCenter.chatRoom.sessionId != null &&
            chatDataCenter.chatRoom.sessionType == 2 &&
            chatDataCenter.chatRoom.userId != null
          ) {
            _this.robotSessionFlag = false;
          } else {
            _this.robotSessionFlag = true;
            _this.icon.operateShow = false;
            _this.icon.emojiShow = false;
          }
        });
        bus.$on("scrollToBottomApp", type => {
          if (_this.myScroll != undefined && _this.myScroll) {
            if (type == "2") {
              setTimeout(function() {
                _this.scrollToBottom();
              }, 700);
            } else {
              setTimeout(function() {
                _this.scrollToBottom();
              }, 200);
            }
          }
        });
        chatDataCenter.set.windowFlag = "1";
        chatDataCenter.chatRoom.readMessages();
        chatDataCenter.scrollToBottom("1");
      },
      scrollToBottom: function() {
        var _this = this;
        _this.myScroll.refresh();
        var elementWrapper = document.getElementById("wrapper");
        var content = document.getElementById("content");
        var notice = document.getElementById("notice");
        var noticeClientHeight = 0;
        if (notice != null) {
          noticeClientHeight = notice.clientHeight;
        }
        if (
          elementWrapper != null &&
          content != null &&
          elementWrapper.clientHeight < content.clientHeight + noticeClientHeight
        ) {
          var height =
            elementWrapper.clientHeight -
            content.clientHeight -
            noticeClientHeight -
            50;
          _this.myScroll.scrollTo(0, height, 500);
        }
      },
      hideIframe: function() {
        if (parent) {
          parent.postMessage("hideIframe", "*");
          chatDataCenter.set.windowFlag = "2";
        }
      },
      _initScroll() {
        var _this = this;
        var pullDownEl = document.getElementById("pullDown");
        var pullDownOffset = pullDownEl.offsetHeight;
        _this.myScroll = new iScroll.iScroll("wrapper", {
          vScroll: true,
          vScrollbar: true,
          onRefresh: function() {
            if (pullDownEl.className.match("loading")) {
              pullDownEl.className = "";
              var pullDownLabel = pullDownEl.querySelector(".pullDownLabel");
              if (pullDownLabel != null) {
                pullDownLabel.innerHTML = "加载更多...";
              }
            }
          },
          onScrollMove: function() {
            if (this.y > 5 && !pullDownEl.className.match("flip")) {
              pullDownEl.className = "flip";
              var pullDownLabel = pullDownEl.querySelector(".pullDownLabel");
              if (pullDownLabel != null) {
                pullDownLabel.innerHTML = "加载更多...";
              }
              this.minScrollY = 0;
            } else if (this.y < 5 && pullDownEl.className.match("flip")) {
              pullDownEl.className = "";
              var pullDownLabel = pullDownEl.querySelector(".pullDownLabel");
              if (pullDownLabel != null) {
                pullDownLabel.innerHTML = "加载更多...";
              }
              this.minScrollY = -pullDownOffset;
            }
          },
          onScrollEnd: function() {
            if (pullDownEl.className.match("flip")) {
              pullDownEl.className = "loading";
              var pullDownLabel = pullDownEl.querySelector(".pullDownLabel");
              if (pullDownLabel != null) {
                pullDownLabel.innerHTML = "加载中...";
              }
              _this.pullDownAction(); // Execute custom function (ajax call?)
            }
          },
          onBeforeScrollStart: null
        });
      },
      /**
       * 加载更多
       */
      pullDownAction: function() {
        var _this = this;
        if (chatDataCenter.isLoadMessage) {
          chatDataCenter.chatRoom.loadHistoryMessages(this, "", function() {
            if (_this.myScroll) {
              setTimeout(function() {
                _this.myScroll.refresh();
              }, 1000);
            }
          });
        }
      },
      /**
       * 按钮点击人工客服
       */
      transferStaffSession: function() {
        chatDataCenter.transferStaffSession(this, 2);
        // chatDataCenter.isOpenFeedback = true;
        // chatDataCenter.isTransformDirectly = true;
      },
      /**
       * 评价
       */
      evaluateByCustomer: function() {
        chatDataCenter.evaluation.closeType = "6"; //顾客主动评价
        chatDataCenter.evaluation.show = true;
      },
      /**
       * 关闭人工会话
       */
      closeSessionByCustomer: function() {
        var _this = this;
        if (chatDataCenter.chatRoom.sessionType == 1) {
          //机器人会话
          _this.hideIframe();
          return false;
        }
        var sessionId = chatDataCenter.chatRoom.sessionId;
        var customerEvaluate = chatDataCenter.chatRoom.customerEvaluate;
        chatDataCenter.evaluation.customerEvaluate = customerEvaluate;
        chatDataCenter.evaluation.sessionId = sessionId;
        chatDataCenter.evaluation.closeType = "1"; //1客户主动关闭
        chatDataCenter.evaluation.show = true;
      },
      quickConsultSendByContent: function(index, content) {
        chatDataCenter.quickConsult.chooseIndex = index;
        chatDataCenter.sendMessageByContent(content);
      },
      /**
       * 发送消息
       */
      sendMessage: function() {
        var _this = this;
        if (_this.sendText == "") {
          return;
        }
        var text = JSON.parse(JSON.stringify(_this.sendText));
        chatDataCenter.sendMessageJudge(this, text, function() {
          chatDataCenter.chatRoom.inputting = text;
          chatDataCenter.chatRoom.sendMessage('input');
          chatDataCenter.clickEvent(text, _this);
          _this.sendText = "";

          if (!_this.icon.operateShow && !_this.icon.emojiShow) {
            document.querySelector(".chat-input").focus();
          }
          setTimeout(() => {
            _this.isShowSuggest = false;
          }, 300);
        });
      },
      fromUploadData(data) {
        var _this = this;
        if (data.flag) {
          var fileObj = {
            url: data.url
          };
          chatDataCenter.sendMessageJudge(_this, "", function() {
            chatDataCenter.chatRoom.sendMessageFile(fileObj, data.messageId);
            if (!_this.icon.operateShow && !_this.icon.emojiShow) {
              document.querySelector(".chat-input").focus();
            }
          });
        }
      },
      /**
       * 表情
       */
      choiceEmoji: function(index) {
        var _this = this;
        _this.sendText += emoji.getEmojiNames(index);
      },
      /**
       * 控制聊天区域
       */
      inputBlurinputBlur: function() {
        var _this = this;
        _this.resolveBug();
        document.getElementById("wrapper").scrollIntoView(false);
        //              document.getElementById("wrapper").scrollIntoViewIfNeeded();
      },
      //微信版本bug解决方法
      resolveBug: function(e) {
        setTimeout(function() {
          // alert(1);
          if (
            document.activeElement.tagName == "INPUT" ||
            document.activeElement.tagName == "TEXTAREA"
          ) {
            return;
          }
          let result = "pc";
          if (common.isIOS()) {
            result = "ios";
          } else if (common.isAndroid()) {
            result = "android";
          }
          if ((result = "ios")) {
            // document.activeElement.scrollIntoViewIfNeeded(true);
          }
        }, 10);
      },
      inputFocus: function() {
        var _this = this;
        _this.icon.focusShow = true;
        _this.icon.operateShow = false;
        _this.icon.emojiShow = false;
        bus.$emit("scrollToBottomApp", "2");
        //              setTimeout(function() {
        //                window.scroll(0,0);
        //              }, 50);
      },
      touchContent: function(el) {
        var _this = this;
        _this.icon.operateShow = false;
        _this.icon.emojiShow = false;
        _this.isShowSuggest = false;
        if (el.target.tagName != "input") {
          _this.inputBlurinputBlur();
          document.querySelector(".chat-input").blur();
          setTimeout(function() {
            window.scroll(0, 0);
          }, 50);
          document.getElementById("wrapper").scrollIntoView(false);
        }
        if (_this.icon.focusShow) {
          _this.icon.focusShow = false;
          bus.$emit("scrollToBottomApp", "1");
        }
      },
      getRobotToUserButton: function() {
        if (
          chatDataCenter.linkInfo != null &&
          chatDataCenter.linkInfo.artificialFlag == 1 &&
          chatDataCenter.chatRoom != null &&
          chatDataCenter.chatRoom.sessionId != null &&
          chatDataCenter.chatRoom.queueFlag == 0 &&
          (chatDataCenter.chatRoom.sessionType == 1 ||
            (chatDataCenter.chatRoom.sessionType == 2 &&
              chatDataCenter.chatRoom.userId == null))
        ) {
          return "1";
        } else if (
          chatDataCenter.chatRoom != null &&
          chatDataCenter.chatRoom.sessionId != null &&
          chatDataCenter.chatRoom.sessionType == 2 &&
          chatDataCenter.chatRoom.userId != null
        ) {
          return "2";
        } else {
          return "3";
        }
      },
      getSuggest: function(e) {
        const that = this;
        const val = e.target.value;
        let questionList = [];
        if (
          chatDataCenter.robotInfo != null &&
          chatDataCenter.robotInfo.bindId != ""
        ) {
          that.$axiosService.getCloud("/cloud/custom/getSimilarQuestions",{
              robotId: chatDataCenter.robotInfo.bindId,
              question: val
            },
            function(response) {
              if (response.success) {
                var res=response.data
                for (var i = 0; i < res.data.length; i++) {
                  if (i < 5) {
                    questionList.push({ text: res.data[i] });
                  }
                }
                if (questionList.length > 0) {
                  that.isShowSuggest = true;
                  that.questionList = questionList;
                } else {
                  that.isShowSuggest = false;
                  that.questionList = res.data;
                }
              }
            }
          );
        }
      },
      sendSuggest: function(text, e) {
        // e.preventDefault();
        text = text
          .replace(new RegExp(/(<em>)/g), "")
          .replace(new RegExp("</em>", "g"), "");
        this.sendText = text;

        this.sendMessage();
        // chatDataCenter.sendMessageByContent(text);
        // this.sendText='';
      },
      // voiceToolShow:function(){
      //   this.isText =  !this.isText;
      // },
      // initWeiXinSdk:function(){
      //   this.fetchWeiXinConfig(function (arr) {
      //     wx.config({
      //       debug: false,//开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      //       appId: 'wxf8ef8d6283d60f53',// 必填，公众号的唯一标识
      //       timestamp: arr[2],/// 必填，生成签名的时间戳
      //       nonceStr: arr[1],// 必填，生成签名的随机串
      //       signature: arr[0],// 必填，签名
      //       jsApiList: [
      //         'startRecord', // 录音开始api
      //         'stopRecord', // 录音结束api
      //         'onVoiceRecordEnd', // 超过一分钟自动停止api
      //         'playVoice', // 播放录音api
      //         'pauseVoice', // 暂停录音api
      //         'stopVoice',    // 停止播放api
      //         'onVoicePlayEnd', // 监听语音播放完毕api
      //         'translateVoice', // 翻译api
      //         'uploadVoice' // 上传音频api
      //       ]// 必填，需要使用的JS接口列表
      //     });
      //     wx.error(function(res){
      //       // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      //       console.log(res);
      //     });
      //     //中间黑色边框和里面的内容（录音状态）
      //     this.$refs.blackBoxSpeak.style.background = "url('../../static/images/app/ic_record@2x.png')no-repeat 28 16px/65px 104px, url('../../static/images/app/ic_record_ripple@2x-9.png')no-repeat 111.2px 32px/28.8px 88px";
      //     this.$refs.blackBoxSpeak.style.backgroundColor = "rgba(0,0,0,.7)";
      //     //中间黑色边框和里面的内容（暂停状态）
      //     this.$refs.blackBoxPause.style.background = "rgba(0,0,0,.7) url('../../static/images/app/ic_release_to_cancel@2x.png')no-repeat center 8px/67.2px 104px";
      //     this.$refs.blackBoxPause.style.backgroundColor = "rgba(0,0,0,.7)";
      //   })
      // },
      fetchWeiXinConfig: function() {
        let url = location.href.split("#")[0];
        this.$axiosService.postCloud("/wechat/getSign", { url }, response => {

          wx.config({
            debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: $config.appId, // 必填，公众号的唯一标识
            timestamp: response.data.data.timestamp, /// 必填，生成签名的时间戳
            nonceStr: response.data.data.nonceStr, // 必填，生成签名的随机串
            signature: response.data.data.signature, // 必填，签名
            jsApiList: [
              "startRecord", // 录音开始api
              "stopRecord", // 录音结束api
              "onVoiceRecordEnd", // 超过一分钟自动停止api
              "playVoice", // 播放录音api
              "pauseVoice", // 暂停录音api
              "stopVoice", // 停止播放api
              "onVoicePlayEnd", // 监听语音播放完毕api
              "translateVoice", // 翻译api
              "uploadVoice" // 上传音频api
            ] // 必填，需要使用的JS接口列表
          });
          wx.error(function(res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。

          });
          //
          // // let result = response.data;
          // callback(response.data)
        });
      },
      // touchstart(event){
      //   console.log(common.isWx(),'---------微信浏览器');
      //   this.isRecording = true;
      //   event.preventDefault();//阻止浏览器默认行为
      //   this.posStart = 0;
      //   this.posStart = event.touches[0].pageY;//获取起点坐标
      //   this.setTimer();
      //   if(common.isWx()){
      //     this.isRecording = true;
      //     // 当用户长按500ms以上再真正开始录音
      //     setTimeout(() => {
      //       this.longPress()
      //     }, 500)
      //   }
      // },
      // longPress(){
      //   wx.startRecord();// 微信开始录音接口
      // },
      // touchmove(event){
      //   this.isRecording = false;
      //   window.clearInterval(this.timer);
      //   if(common.isWx()){
      //     event.preventDefault(); //阻止浏览器默认行为
      //     this.posMove = event.targetTouches[0].pageY;
      //     if (this.posStart - this.posMove < 200) {
      //       //隐藏录音 显示暂停
      //       this.isPause = true
      //     } else {
      //       //显示录音 隐藏暂停
      //       this.isRecording = true
      //     }
      //
      //     wx.stopRecord({ // 微信结束录音接口
      //       success: res => {
      //         this.isRecording = false;
      //         this.voice.localId = res.localId;
      //         console.log('中断结束录音');
      //       }
      //     })
      //   }
      // },
      // touchend(event){
      //   this.isRecording = false;
      //   window.clearInterval(this.timer);
      //   if(common.isWx()) {
      //     event.preventDefault(); //阻止浏览器默认行为
      //     this.posEnd = 0;
      //     this.posEnd = event.changedTouches[0].pageY;//获取终点坐标
      //     wx.stopRecord({ // 微信结束录音接口
      //       success: res => {
      //         this.isRecording = false;
      //         this.voice.localId = res.localId;
      //         console.log('正常结束录音成功了')
      //       }
      //     })
      //   }
      // },
      // setTimer:function() {
      //     let that = this;
      //     that.timer = setInterval(function () {
      //       setTimeout(function () {
      //         that.num++;
      //         that.$refs.blackBoxSpeak.style.background = "url('../../static/images/app/ic_record@2x.png')no-repeat 28px 16px/64px 104px, url('../../static/images/app/ic_record_ripple@2x-" + that.index[that.num] + ".png')no-repeat 111.2px 32px/28.8px 88px";
      //         that.$refs.blackBoxSpeak.style.backgroundColor = " rgba(0,0,0,.7)";
      //       }, 70);
      //       if (that.num >= that.index.length - 1) {
      //         that.num = 0;
      //       }
      //     }, 70);
      // },
      foldMore(item){
        item.height = item.isOpen ? "245px" : "unset";
        item.isOpen = !item.isOpen;
        setTimeout(() => {
          this.myScroll.refresh();
        }, 500);
        const chatId=  JSON.parse(item.messageContent).chatId;
      },
      cancel(){
        this.showModal = false;
      },
      showVoice() {
        this.isVoice = !this.isVoice;
      },
      longPress() {
        const that = this;
        wx.startRecord({
          success (res) {
            console.log('录音功能调用成功============')
            that.showModal = true;
          },
          fail(res){
            console.log('录音功能调用失败============')
          }
        }); // 微信开始录音接口
      },
      start(event) {
        clearTimeout(this.loop); //再次清空定时器，防止重复注册定时器
        const that = this;
        // event.preventDefault();
        if (common.isWx()) {
          this.loop = setTimeout(() => {
            this.longPress();
          }, 500);
        }
      },
      end(event) {
        clearTimeout(this.loop); //清空定时器，防止重复注册定时器
        // event.preventDefault();
        this.showModal = false;
        let that = this;
        if (common.isWx()) {
          wx.stopRecord({
            // 微信结束录音接口
            success: res => {
              // this.voice.localId = res.localId;

              that.transferVoice(res.localId);
            }
          });
        }
      },
      transferVoice(localId) {
        let that = this;
        wx.translateVoice({
          localId, // 需要识别的音频的本地Id，由录音相关接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: function(res) {

            // alert(res.translateResult); // 语音识别的结果
            that.sendText = res.translateResult;
            that.isVoice = false;
          }
        });
      },
      reJoin:function () {
        chatDataCenter.clickEvent('#重新接入#',this)
      },
    },
    data() {
      return {
        myScroll: null,
        chatDataCenter,
        sendText: "",
        robotSessionFlag: true,
        icon: {
          emojiShow: false,
          operateShow: false,
          focusShow: false
        },
        image: {
          flag: false,
          type: "icon_multiple_h5_pic",
          className: "bottom-file",
          iconName: ""
        },
        video: {
          flag: false,
          type: "icon_multiple_h5_video",
          className: "bottom-file",
          iconName: ""
        },
        notice: {
          show: false
        },
        emoji: emoji,
        isShowSuggest: false,
        questionList: [],
        // isText:false,
        // voice:{
        //   localId: '',
        //   serverId: ''
        // },
        // isRecording:false,
        // isPause:false,
        // posStart:0,
        // posEnd:0,
        // posMOve:0,
        // index:[9, 8, 7, 6, 5, 4, 3, 2, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        // num:18,
        // timer:null
        showModal:false,
        isVoice:false,
        isWeixin:false,
        paragraph: {
          type: "row",
          rows: [
            {
              type: "col",
              cols: [
                {
                  type: "row",
                  style: {
                    width: "15%",
                  },
                  rows: [
                    {
                      type: "circle",
                      style: {
                        width: "40px",
                        height: "40px",
                      },
                    },
                  ],
                },
                {
                  colStyle: {
                    marginLeft: "15px",
                    width: "45%",
                  },
                  type: "row",
                  rows: [
                    {
                      rowStyle: {
                        marginTop: "4px",
                      },
                      type: "rect",
                      style: {
                        width: "100%",
                        height: "18px",
                      },
                    },
                    {
                      type: "rect",
                      rowStyle: {
                        marginTop: "10px",
                      },
                      style: {
                        width: "100%",
                        height: "12px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              rowStyle: {
                marginTop: "10px",
              },
              type: "col",
              cols: [
                {
                  colStyle: {
                    marginLeft: "calc(100% - 45% - 50px)",
                    marginRight: "10px",
                    width: "45%",
                  },
                  type: "row",
                  rows: [
                    {
                      rowStyle: {
                        marginTop: "4px",
                      },
                      type: "rect",
                      style: {
                        width: "100%",
                        height: "18px",
                      },
                    },
                    {
                      type: "rect",
                      rowStyle: {
                        marginTop: "10px",
                      },
                      style: {
                        width: "100%",
                        height: "12px",
                      },
                    },
                  ],
                },
                {
                  type: "row",
                  style: {
                    width: "15%",
                  },
                  rows: [
                    {
                      type: "circle",
                      style: {
                        width: "40px",
                        height: "40px",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      };
    }
  };
</script>

<style scoped>
  @import "../../../static/css/appMain.css";
  .operateShow {
    padding-bottom: 0 !important;
  }
  .operateShow-footer-first {
    height: 55px !important;
    border-radius: 8px 8px 0 0 !important;
  }
  .smartnlp-suggest {
    width: 100%;
    background: #ffffff;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    z-index: 9;
    /* position: fixed; */
    bottom: 60px;
    max-height: 200px;
    overflow: auto;
  }
  .smartnlp-suggest ul li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f0f0f0;
    padding: 0 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-size: 13px;
    color: #333;
    margin: 0;
    display: flex;
    width: 100%;
  }
  .smartnlp-suggest ul li img {
    width: 20px;
    margin-top: 10px;
    height: 20px;
  }
  .smartnlp-suggest ul li em {
    color: #ff1800;
    font-style: normal;
  }
  .smartnlp-suggest ul li span {
    padding-left: 10px;
    vertical-align: middle;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .openMore {
    text-align: center;
    font-size: 14px;
    color: #717688;
    margin: 8px 15px;
    padding: 5px 0;
    border-top: 1px solid #ebebeb;
  }
  .openImg {
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
  .chat-input {
    background: #fff;
    border-radius: 0;
  }
  .chatTalk {
    text-align: center;
    line-height: 38px;
    padding: 0px !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .yuyin{
    padding-top: 11px;
    padding-left: 5px;
    width: 30px;
  }
  .yuyin img {
    width: 26px;
    height: 26px;
    vertical-align: middle;
  }
  .voiceStart {
    width: 55px;
    height: 55px;
    background: url("../../../static/images/voiceStart.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    top: calc(-55px / 2);
    left: calc((100% - 55px) / 2);
  }
  .voiceBox {
    width: 100%;
    height: 35px;
    background: url("../../../static/images/bj.png");
    background-size: 100%;
  }
  .keywordBack{
    background: url("../../../static/images/keyword.png");
    background-size: cover;
    width: 26px;
    height: 26px;
    vertical-align: middle;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0 !important;
    margin-top: 11px;
    margin-left: 5px;
  }
  .addpng{
    background: url("../../../static/images/add.png");
    background-size: cover;
    width: 26px;
    height: 26px;
    vertical-align: middle;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0 !important;
    margin-top: 11px;
    margin-left: 8px;
    margin-right: 4px;
  }
  .closeOperation{
    background: url("../../../static/images/closeOperation.png");
    background-size: cover;
    width: 26px;
    height: 26px;
    vertical-align: middle;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0 !important;
    margin-top: 11px;
    margin-left: 8px;
    margin-right: 4px;
  }
</style>
